// USER-CODE-ORIGIN: the smbls runtime TEXT the opaque user-code frame boots
// from (shared functions/iframeApp/userCodeFrame.js reads it through
// `el.call('userCodeRuntimeText')`). It lives in packages/workspace ONLY — the
// one package no other library bundles (frameworks ruling 2026-10-10): shared,
// preview and canvas reach it through the call, so the 595 KB string never
// rides a library's published data. frank bundles a dynamic
// `import('smbls/iife-string')` into the emitted library, and the 614 KB minified module's names collided with a
// lifted helper (`globalScope.G` lost its peer `u`: PUBLISH BLOCKED,
// unresolvable-identifier — measured 2026-10-10, fieldKitNameSurvivesFrank).
// The same import already ships in the shell's M2 sandbox and emits clean
// there. A lazy chunk: only a mount of user code pays for it.
export const userCodeRuntimeText = () => import('smbls/iife-string').then((m) => m.default || m)
